import { useMemo } from 'react';
import { UserWithMembership } from '@/hooks/useUsers';
import { fuzzyMatch } from '@/utils/fuzzySearch';

export const useFuzzyUserSearch = (users: UserWithMembership[], searchTerm: string) => {
  return useMemo(() => {
    if (!searchTerm.trim()) {
      return users;
    }

    return users.filter(user => {
      // Search in full name
      if (fuzzyMatch(searchTerm, user.full_name)) {
        return true;
      }
      
      // Search in email (if exists)
      if (user.email && fuzzyMatch(searchTerm, user.email, 0.7)) {
        return true;
      }
      
      return false;
    });
  }, [users, searchTerm]);
};